<app-header></app-header>

<div class="container photographer-layout">
  <app-photographer-profile
    [photographer]="photographer"
    (bookNow)="openBookNowModal()"
  ></app-photographer-profile>

  <div class="photographer-layout__feed">
    <app-photographer-services
      [services]="photographer?.services ?? null"
      [photographerFirstName]="photographer?.firstname ?? ''"
    ></app-photographer-services>
    @if (portfolio === null || portfolio.length > 0) {
      <app-photographer-portfolio
        [portfolio]="portfolio"
      ></app-photographer-portfolio>
    }
  </div>
</div>

<app-photographer-book-now-modal
  [isOpen]="bookNowModalOpened"
  [photographer]="photographer"
  (onClose)="closeBookNowModal()"
></app-photographer-book-now-modal>
